import axios, { axiosInstanceForRefreshToken } from 'api';

// const captchaValue = recaptcha.current.getValue();
const config = {
  // body: JSON.stringify({ captchaValue }),
  headers: {
    // withCredentials: true
  }
};
export const login = async (payload) => {
  return axios.post(
    `/api/account/login/`,
    {
      username: payload.email,
      password: payload.password
    },
    config
  );
};

export const refreshTokenAPI = (params) => {
  const user = {
    refresh: params
  };
  return axiosInstanceForRefreshToken.post(`api/account/refresh_token/`, user);
};

export const reCaptchaVarify = (params) => {
  return axios.post('api/account/captcha_verify/', params);
};

export const getTenantLogo = (params) => {
  return axios.get(`api/tenant/get-tenant-logo/?tenant=${params.tenant}`);
};
